import type { HolterDirectExaminationRequestData } from '@common/validation/customControls/cardiology/holter/holterDirectExaminationRequestSchemas';
import { CustomControlCode, ValidationSchemaVersion } from '@common/enums';
import { getCustomControlValidationSchemaContainer } from '@common/workflow/serviceActivityRegistration';
import { useProcessActivityEditContext } from '@frontend/utils/hooks/useProcessActivityContext';
import { validate } from '@frontend/utils/validation';
import { scrollToRefValidationError } from '@frontend/utils/validationScrollUtils';
import { HolterConfigureButton } from '../customComponents/HolterConfigureButton';

export function HolterDirectExaminationHolterConfigureButton(): JSX.Element {
    const { data, formRef, processActivityId, onChange, processActivityContextData } =
        useProcessActivityEditContext<HolterDirectExaminationRequestData>();

    return (
        <HolterConfigureButton
            name="Stel in"
            onChange={onChange}
            onValidate={onValidate}
            processActivityId={processActivityId}
            showHolterInstructionModal={true}
        />
    );

    async function onValidate() {
        const { hasErrors } = validate(
            getCustomControlValidationSchemaContainer(
                CustomControlCode.HolterDirectExaminationRequest,
                ValidationSchemaVersion.final,
                1
            ),
            processActivityContextData
        );

        if (hasErrors) {
            const validateKeys = getAllDataKeys();
            await onChange({}, validateKeys);
        }

        scrollToRefValidationError(formRef);

        return hasErrors;
    }

    function getAllDataKeys(): string[] {
        const keys: string[] = [];

        Object.keys(data).forEach((key) => {
            if (key === 'labResults' && Array.isArray(data.labResults) && data.labResults.length > 0) {
                data.labResults.forEach((item, idx) => {
                    Object.keys(item).forEach((prop) => {
                        keys.push(`labResults.${idx}.${prop}`);
                    });
                });
            } else if (key === 'episodesAndJournals' && data.episodesAndJournals) {
                if (Array.isArray(data.episodesAndJournals.episodes) && data.episodesAndJournals.episodes.length > 0) {
                    data.episodesAndJournals.episodes.forEach((item, idx) => {
                        Object.keys(item).forEach((prop) => {
                            keys.push(`episodesAndJournals.episodes.${idx}.${prop}`);
                        });
                    });
                }
                if (
                    Array.isArray(data.episodesAndJournals.journalEntries) &&
                    data.episodesAndJournals.journalEntries.length > 0
                ) {
                    data.episodesAndJournals.journalEntries.forEach((item, idx) => {
                        Object.keys(item).forEach((prop) => {
                            keys.push(`episodesAndJournals.journalEntries.${idx}.${prop}`);
                        });
                    });
                }
            } else {
                keys.push(key);
            }
        });

        return keys;
    }
}
